import React, { useMemo } from "react"
import { Link, useParams } from "react-router-dom"
import { DateTime } from "luxon"
import { ActivityReservationCreated } from "@/types/activities"
import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"
import Changes from "@/components/activities/changes"
import { reservationEditPath } from "@/shared/urls"

interface CreatedProps {
  activity: ActivityReservationCreated & { resource?: { __typename: string; id: string } | null }
  className?: string
}

const Created = ({ activity, className }: CreatedProps) => {
  const { slug } = useParams<{ slug: string }>()

  const LABELS = {
    startTime: i18n.t("app.activities.reservation.field_labels.start_time"),
    endTime: i18n.t("app.activities.reservation.field_labels.end_time"),
    peopleAmount: i18n.t("app.activities.reservation.field_labels.people_amount"),
    tableId: i18n.t("app.activities.reservation.field_labels.table"),
  }

  const formatters = useMemo(() => {
    return {
      startTime: (value) => DateTime.fromISO(value).toLocaleString(DateTime.TIME_24_SIMPLE),
      endTime: (value) => DateTime.fromISO(value).toLocaleString(DateTime.TIME_24_SIMPLE),
    }
  }, [])

  const { startTime, endTime, peopleAmount, tableId } = activity.parameters
  const changes = { startTime, endTime, peopleAmount, tableId }

  const resourceLink =
    activity.resource?.__typename === "Reservation" && slug ? (
      <Link to={reservationEditPath(slug, activity.resource.id)} className="text-blue-500 hover:underline">
        #{activity.resource.id}
      </Link>
    ) : null

  return (
    <ActivityBase
      data-testid="panel-activity-reservation-created"
      activityKey={activity.key}
      createdAt={activity.createdAt}
      text={
        <>
          {i18n.react("app.activities.reservation.created.description", {
            owner: <OwnerLabel owner={activity.owner} />,
            resourceLink,
          })}
          <Changes changes={changes} labels={LABELS} formatters={formatters} />
        </>
      }
      className={className}
    />
  )
}

export default Created
